import React, { Component } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import QuillImageDropAndPaste from 'quill-image-drop-and-paste';
import QuillResize from 'quill-resize-module';
import 'react-quill/dist/quill.snow.css';
import 'quill-mention';
import 'quill-mention/dist/quill.mention.css';
import { getTheme } from '../../config/getTheme';
import { COLORS } from '../../config/theme';
import { authenticatedRequest } from '../../api';
import { get_document, post_document } from '../../apis/document-manager';
import ReactDOMServer from 'react-dom/server';
import { RiFingerprintFill, RiLineHeight, RiQrCodeLine } from 'react-icons/ri';
import QRCode from '../QuillEditor/Components/QRCode';
import lineHeightStyle from '../QuillEditor/Components/LineHeight';

Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);
Quill.register('modules/resize', QuillResize);
Quill.register(Quill.import('attributors/style/font'), true);
Quill.register(Quill.import('attributors/style/direction'), true);
Quill.register(Quill.import('attributors/style/align'), true);
Quill.register('formats/qr-code', QRCode);
Quill.register({ 'formats/lineHeight': lineHeightStyle }, true);

const icons = Quill.import('ui/icons');
icons['signature'] = ReactDOMServer.renderToString(<RiFingerprintFill size={18} />);
icons['qr-code'] = ReactDOMServer.renderToString(<RiQrCodeLine size="18px" />);
icons['lineHeight'] = ReactDOMServer.renderToString(<RiLineHeight size="18px" />);

// const formats = [
//     'header',
//     'bold',
//     'italic',
//     'underline',
//     'alt',
//     'style',
//     'strike',
//     'blockquote',
//     'width',
//     'size',
//     'height',
//     'list',
//     'bullet',
//     'indent',
//     'link',
//     'image',
//     'mention',
//     'resize',
//     'align',
//     'color',
//     'qr-code',
//     'signature',
//     'lineHeight',
// ];

const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link'];

interface Props {
    setContent: (content) => void;
    atValues: any[];
    value?: string;
    canAddSignature?: boolean;
    setAddSignatureVisible?: (boolean) => void;
}

export default class RichTextEditor extends Component<Props, { value: string }> {
    private quillEditorRef: any;
    constructor(props) {
        super(props);
        this.quillEditorRef = React.createRef();
        this.state = {
            value: '',
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>) {
        if (prevProps.value !== this.props.value && this.props.value) {
            console.log('test', this.props.value);
            this.setState({
                value: `<p><strong>Beneficiary: DIRECTOR GENERAL,</strong></p><p><strong>&nbsp;\t&nbsp;&nbsp;&nbsp;&nbsp;KENYA RURAL ROADS AUTHORITY, &nbsp;&nbsp;&nbsp;</strong></p><p><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;P. O. BOX 48151-00100,&nbsp;</strong></p><p><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;NAIROBI.</strong></p><p><strong>Invitation to Tender No. KERRA/08/39/34/2021-22</strong></p><p><strong>Date: 18TH FEBRUARY 2022</strong></p><p><br></p><p><strong>Tender Guarantee No……..</strong></p><p><strong>Guarantor: SMEP MICROFINANCE BANK LIMITED OF P. O. BOX 64063 - 00620, NAIROBI</strong></p><p><br></p><p>\t</p><p>We have been informed that <strong>STEWARD HOLDINGS LIMITED </strong>of<strong> P.O. Box 18539-00100 NAIROBI (</strong>hereinafter called “the Applicant”) has submitted to the Beneficiary its Tender (hereinafter called “<em>The Tender</em>”) for the execution of <strong>SPOT IMPROVEMENT AND ROUTINE MAINTENANCE OF ANGELS INDUSTRIAL - RUIRU ROAD </strong>under Request for Tenders No<strong>.</strong> <strong>KERRA/08/39/34/2021-22 </strong>(‘The ITT’)</p><p><br></p><p>Furthermore, we understand that, according to the Beneficiary’s conditions, Tender must be supported by a Tender Guarantee.</p><p><br></p><p>At the request of the Applicant, we, as Guarantor, hereby irrevocably undertake to pay the Beneficiary any sum or sums not exceeding in total an amount of <strong>Kenya Shillings Four Hundred Thousand only (KSH. 400,000.00)</strong> upon receipt by us of the Beneficiary’s complying demand, supported by the Beneficiary’s statement, whether in the demand itself or a separate signed document accompanying or identifying the demand, stating that either the Applicant:&nbsp;</p><p><br></p><p><br></p><ol><li>Has withdrawn its Tender during the period of Tender validity set forth in the Applicant’s letter of Tender (“the tender validity period”), or any extension there to be provided by the Applicant; or&nbsp;</li><li>Having been notified of the acceptance of its Tender by the Beneficiary during the Tender validity period or any extension thereto provided by the Applicant, (i) has Failed to execute the Contract Agreement, or (ii) Has Failed to furnish the Performance security.</li></ol><p>\t</p><p>This guarantee will expire:&nbsp;</p><p><br></p><p><strong>(a)</strong> if the Applicant is the successful Tenderer, upon our receipt of copies of the Contract agreement signed by the Applicant and the Performance Security and , or ;</p><p><strong>(b)</strong> if the Applicant is not the successful Tenderer, upon the earlier of;(i) Our receipt of a copy of the Beneficiary’s notification to the Applicant of the results of the Tendering process; or (ii) Twenty-Eight days after the end of the Tender Validity Period.&nbsp;</p><p><br></p><p>Consequently, any demand for payment under this Guarantee must be received by us at the office indicated above or on before <strong>18TH FEBRUARY 2023.</strong></p><p><br></p><p><br></p><p><strong>AUTHORISED SIGNATORY &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AUTHORISED SIGNATORY</strong></p><p><br></p>`,
            });
        }
    }

    addQRCode = () => {
        const editor = this.quillEditorRef?.current?.getEditor();
        const position = editor.getLength();
        editor.insertEmbed(position, 'qr-code', true);
    };

    imageHandler = (_, __, imageData) => {
        const file = imageData.toFile();
        const formData = new FormData();
        formData.append('document', file);
        authenticatedRequest()
            .post(post_document, formData)
            .then((res) => {
                const downloadURL = res?.data?.downloadURl;
                const editor = this.quillEditorRef?.current?.getEditor();
                const editorSelection = editor?.getSelection();
                const editorLength = editor?.getLength();
                let index = (editorSelection || {}).index;
                if (index === undefined || index < 0) index = editorLength;
                editor?.insertEmbed(
                    index,
                    'image',
                    `${process.env.REACT_APP_API_BASE_URL}/${get_document(downloadURL)}`,
                    'user',
                );
            })
            .catch((error) => {
                console.log('error', error);
            });
    };
    modules = {
        toolbar: {
            container: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                [{ color: ['#39426A', '#777C93', `${getTheme()[COLORS.PRIMARY]}`] }],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ indent: '-1' }, { indent: '+1' }],
                ['link'],
                // ['lineHeight'],
                // ['qr-code'],
                // ['signature'],
            ],
            // handlers: {
            //     // handlers object will be merged with default handlers object
            //     signature: function () {
            //         // setAddSignatureVisible?.(true);
            //     },
            //     'qr-code': function () {
            //         // this.addQRCode();
            //     },
            //     lineHeight: () => {
            //         // setLineSpacingVisible(true);
            //     },
            // },
        },
        // mention: {
        //     allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        //     mentionDenotationChars: ['@'],
        //     source: (searchTerm, renderList) => {
        //         const values = [] as any;
        //         if (searchTerm.length === 0) {
        //             renderList(this.props.atValues, searchTerm);
        //         } else {
        //             const matches = [] as any;
        //             for (let i = 0; i < this.props.atValues.length; i++)
        //                 if (values && values[i]?.value?.toLowerCase()?.indexOf(searchTerm?.toLowerCase()))
        //                     matches.push(values[i]);
        //             renderList(matches, searchTerm);
        //         }
        //     },
        //     onSelect: function (item, insertItem) {
        //         insertItem(item, true);
        //     },
        // },
        // imageDropAndPaste: {
        //     // add a custom image handler
        //     handler: (imageDataUrl, type, imageData) => this.imageHandler(imageDataUrl, type, imageData),
        // },
        // resize: {
        //     modules: ['Resize', 'DisplaySize'],
        // },
    };
    render() {
        return (
            <ReactQuill
                ref={this.quillEditorRef}
                theme="snow"
                // modules={this.modules}
                // formats={formats}
                value={this.state.value}
                onChange={(val) => this.props.setContent(val)}
            />
        );
    }
}
